export default __webpack_public_path__ + "static/international-yards-desktop-17c8bdc1ace5cf6d24b4ef7055f0753b.svg";